import { DisplayCaretContainer } from '@dealstack/frontend/shared/components/forms/SearchSelectWithNestedCollapsableChildren/styled';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';

interface Props {
	isOpen: boolean;
	onClick: () => void;
}

export const DisplayCaret = ({ isOpen, onClick }: Props) => {
	return (
		<DisplayCaretContainer
			onClick={(e) => {
				e.stopPropagation();
				onClick?.();
			}}
		>
			{!isOpen && <Icon variant="caret-down" size="lg" />}{' '}
			{isOpen && <Icon variant="caret-up" size="lg" />}
		</DisplayCaretContainer>
	);
};
